import { RestApiDataService } from '@/services/api/RestApiDataService'
import RegionSelectField from '@/components/ui/crud/fields/RegionSelectField.vue'
import OrganizationSelectField from '@/components/ui/crud/fields/OrganizationSelectField.vue'
import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
import SnoType from '@/models/enums/SnoType'
import FilialSettingsForm from '@/components/ui/crud/fields/filials/FilialSettingsForm.vue'
import PriceListSelectField from '@/components/ui/crud/fields/PriceListSelectField.vue'
import { VCheckbox, VTextField } from 'vuetify/lib'
import ReadOnlyTextField from '@/components/ui/crud/fields/ReadOnlyTextField.vue'
import SourcesField from '@/components/ui/crud/fields/filials/SourcesField.vue'

const BASE_ENTITY_URL = '/filials'

class FilialDataService extends RestApiDataService {
  getCrudFields () {
    return [
      {
        key: 'name',
        label: 'Название',
        component: VTextField,
        rules: ['required'],
      },
      { key: 'connectionDate' },
      {
        key: 'organizationId',
        label: 'Юрлицо',
        component: OrganizationSelectField,
      },
      {
        key: 'jupiterSync',
        label: 'Синхронизация с юпитер включена',
        component: VCheckbox,
        defaultValue: true,
      },
      { key: 'jupiterId', label: 'ID в Юпитер', component: VTextField },
      { key: 'regionId', label: 'Регион', component: RegionSelectField },
      {
        key: 'city',
        label: 'Город (указанный в адресе)',
        component: VTextField,
      },
      { key: 'requisites', label: 'Реквизиты', component: VTextField },
      {
        key: 'address',
        label: 'Адрес',
        component: VTextField,
        rules: ['required'],
      },
      { key: 'metro', label: 'Метро', component: VTextField },
      {
        key: 'minOrderCost',
        label: 'Минимальная сумма заказа',
        component: VTextField,
        rules: ['number'],
      },

      {
        key: 'sortOrder',
        label: 'Индекс сортировки',
        component: VTextField,
        rules: ['number'],
      },
      {
        key: 'workPhone',
        label: 'Рабочий телефон филиала',
        component: VTextField,
      },
      { key: 'lat', label: 'lat (координата)', component: VTextField },
      { key: 'let', label: 'lat (координата)', component: VTextField },

      { key: 'startTime', label: 'Время открытия', component: VTextField },
      { key: 'endTime', label: 'Время закрытия', component: VTextField },

      {
        key: 'snoType',
        label: 'Система налогообложения',
        rules: [
          /* 'required' */
        ],
        component: EnumValueSelectField,
        enumClass: SnoType,
      },

      {
        key: 'basePriceListId',
        label: 'Базовый прайс-лист',
        component: PriceListSelectField,
        defaultValue: null,
      },
      {
        key: 'sources',
        component: SourcesField,
      },
      {
        key: 'kuperEnabled',
        label: 'Работает с Купер',
        component: VCheckbox,
        defaultValue: false,
      },
      // {
      //   key: 'aggregatorsPriceListId',
      //   label: 'Прайс-лист для продажи в агрегаторах',
      //   component: PriceListSelectField,
      //   defaultValue: null,
      // },
      // {
      //   key: 'setDeliveryPriceListId',
      //   label: 'Прайс-лист для продажи под суббрендом Сетдоставка',
      //   component: PriceListSelectField,
      //   defaultValue: null,
      // },
      // {
      //   key: 'wellFedElephantPriceListId',
      //   label: 'Прайс-лист для продажи под суббрендом Сытый слон',
      //   component: PriceListSelectField,
      //   defaultValue: null,
      // },

      // { key: 'kkmServerUrl', label: 'Адрес KkmServer', component: ReadOnlyTextField },
      {
        key: 'settings',
        label: 'Настройки филиала',
        component: FilialSettingsForm,
      },

      { key: 'franchise', label: 'Франшиза', component: VCheckbox },
      {
        key: 'hasPickup',
        label: 'Возможен самовывоз',
        component: VCheckbox,
        defaultValue: true,
      },
      {
        key: 'isCallCenter',
        label: 'Является Колл-центром',
        component: VCheckbox,
        defaultValue: false,
      },
      {
        key: 'useCallCenter',
        label: 'Работает с колл-центром',
        component: VCheckbox,
        defaultValue: false,
      },
      {
        key: 'setdelivery',
        label: 'Работает с брендом СетДоставка',
        component: VCheckbox,
        defaultValue: false,
      },
      {
        key: 'wellFedElephant',
        label: 'Работает с брендом Сытый слон',
        component: VCheckbox,
        defaultValue: false,
      },
      {
        key: 'status',
        label: 'Филиал активен',
        component: VCheckbox,
        defaultValue: true,
      },
      {
        key: 'archived',
        label: 'Архивный филиал (Доступен только для статистики)',
        component: VCheckbox,
        defaultValue: true,
      },
    ]
  }

  getUseCallCenterItems () {
    return this.getCustomItems('use-call-center')
  }

  getAll () {
    return this.getCustomItems('all')
  }

  getPickupPoints () {
    return this.getCustomItems('pickup')
  }

  getAvailableForOrder () {
    return this.getCustomItems('available-for-order')
  }

  // ключ вкладки-прокси ККМ: в ресурсах филиала его нет, только эта ручка (право crm.kkm-server)
  getPrintApiKey (id) {
    return this.http.get(`${this.baseEntityUrl}/${id}/print-api-key`).then(res => res.data.printApiKey)
  }
}

export default new FilialDataService(BASE_ENTITY_URL)
